import script from "./tabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./tabBar.vue?vue&type=script&setup=true&lang=js"

import "./tabBar.vue?vue&type=style&index=0&id=936995ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-936995ea"]])

export default __exports__